import {object, SchemaOf, string} from 'yup';

import {IdentityCardRequestBody} from '../types/IdentityCardRequestBody';
import {$IdentityCardData} from './$IdentityCardData';

export const $IdentityCardRequestBody: SchemaOf<IdentityCardRequestBody> = object({
  id: string().defined().nullable(),
  cardData: $IdentityCardData.defined(),
});
